import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import Popup from 'components/popup/popup';
import { setGlobal, setGlobalLoading } from 'store/global/reducer';
import { GET_DOWNLOAD_DOCUMENT } from 'store/key';
import { useDispatch, useSelector } from 'react-redux';
import useDialog from 'components/ConfirmDialog/useDialog';
import CustomDatePicker from 'components/Input/CustomDatePicker';
import UploadWrapper from 'components/UploadWrapper';
import {
    CCO,
    IRB,
    SECRETARY,
} from 'utility/lookup';
import API from 'api/call';
import LoadingIndicator from 'components/LoadingIndicator';
import CustomLink from 'components/CustomLink';

const SLayout = styled.div`
    padding: 15px;
    width: 500px;
`;

const SSelectLayout = styled.div`
    margin-top: 10px;
    /* width: 500px; */
`;

const SDocumentUploadLayout = styled.div`
    margin-top: 20px;
    /* display: flex;
    align-items: flex-start; */
`;

const ViewApprovalLetter = ({ open }) => {
    const dispatch = useDispatch();
    const showDialog = useDialog();
    const modalRefID = useSelector((state) => state.global.modalRefID);
    const userRole = useSelector(state => state.user.role);
    const systemMessage = useSelector(state => state.systemMessage.systemMessage);

    const showReUpload = [IRB, SECRETARY].includes(userRole);
    const isUpdateDate = [CCO, SECRETARY, IRB].includes(userRole);
    const noChanges = !showReUpload && !isUpdateDate;

    const [approvalExpiryDate, setApprovalExpiryDate] = useState(null);

    const [approvalUpload, setApprovalUpload] = useState({});
    const [downloadType, setDownloadType] = useState(null);
    const [fileId, setFileId] = useState(null);

    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (open) {
            setApprovalUpload({});
            loadData();
        }
        // eslint-disable-next-line
    }, [open]);

    const loadData = () => {
        setIsLoading(true);
        API.application.viewApprovalLetter({ id: modalRefID })
            .then(res => {
                const data = res?.data?.result;
                setApprovalExpiryDate(data?.approvalExpiryDate);
                setDownloadType(data?.downloadType);
                setFileId(data?.fileId);
            })
            .finally(() => setIsLoading(false));
    };

    const checkValid = () => {
        let valid = true;
        if (!approvalUpload.fileName && !approvalExpiryDate) {
            valid = false;
            showDialog({
                description: systemMessage.warnChosenDateOrFile,
                disableCancelButton: true,
            });
        }

        return valid;
    };

    const confirm = async () => {
        if (checkValid()) {
            setGlobalLoading(true);
            const requestData = {
                uploadTempId: approvalUpload.key ?? '',
                approvalExpiryDate: approvalExpiryDate ? new Date(approvalExpiryDate) : null,
            };
            API.application.saveReuploadApprovalLetter({ id: modalRefID, data: requestData })
                .then(() => {
                    showDialog({
                        description: systemMessage.updateSuccess,
                        disableCancelButton: true,
                    });
                    cancel();
                })
                .finally(() => setGlobalLoading(false));
        }
    };

    const cancel = () => {
        dispatch(
            setGlobal({
                isShowViewApprovalLetter: false,
                modalRefID: null,
            }),
        );
    };

    const getDownloadDocument = () => {
        dispatch({
            type: GET_DOWNLOAD_DOCUMENT,
            payload: {
                data: {
                    id: fileId,
                    type: downloadType,
                },
            },
        });
    };

    const onFileUploaded = (list) => {
        setApprovalUpload(list[0]);
    };

    const actions = noChanges ? [{ label: 'Close', clicked: cancel }] : [
        { label: 'Cancel', clicked: cancel, color: 'default' },
        { label: 'Confirm', clicked: confirm },
    ];

    return (
        <Popup
            title="Download Approval Letter"
            open={open}
            footerActions={actions}
            closePopup={cancel}
        >
            <SLayout>
                {isLoading ? <LoadingIndicator/> : <>
                    <SSelectLayout style={{ marginTop: 30 }}>
                        <CustomDatePicker
                            disabled={!isUpdateDate}
                            name={'approvalExpiryDate'}
                            label={'Approval Expiry date'}
                            value={approvalExpiryDate}
                            onChange={(date) => {
                                setApprovalExpiryDate(date);
                            }}
                        />
                    </SSelectLayout>

                    <div style={{ display: 'flex', marginTop: 30 }}>
                        Click
                        <CustomLink
                            onClick={getDownloadDocument}
                            style={{ padding: '0 10px'}}
                            isChangeColor
                            isStopJumping
                        >
                            here
                        </CustomLink>
                        to download Approval letter
                    </div>

                    {showReUpload && <SDocumentUploadLayout>
                        Re-Upload signed approval letter to Confirm:
                        <div style={{ marginTop: 10 }}>
                            <UploadWrapper
                                onFileUploadFinish={onFileUploaded}
                                multiple={false}
                                isRequired
                                files={
                                    approvalUpload.key
                                        ? [{ name: approvalUpload.fileName, downloadId: approvalUpload.key }]
                                        : []
                                }
                                inputStyle
                                inputStyleText={'Re-Upload Approval Letter'}
                                enableRemove
                                onRemove={() => {
                                    setApprovalUpload({});
                                }}
                            />
                        </div>
                    </SDocumentUploadLayout>
                }</>}
            </SLayout>
        </Popup>
    );
};

export default ViewApprovalLetter;
